import { render, staticRenderFns } from "./leaveapplication.vue?vue&type=template&id=5873dfec&scoped=true"
import script from "./leaveapplication.vue?vue&type=script&lang=js"
export * from "./leaveapplication.vue?vue&type=script&lang=js"
import style0 from "./leaveapplication.vue?vue&type=style&index=0&id=5873dfec&prod&lang=scss&scoped=true"
import style1 from "./leaveapplication.vue?vue&type=style&index=1&id=5873dfec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5873dfec",
  null
  
)

export default component.exports